import de from "./de.json";

const dict: Record<string, string> = de as Record<string, string>;

export function t(key: string, vars?: Record<string, string | number>): string {
  const tmpl = dict[key] ?? key;
  if (!vars) return tmpl;
  return tmpl.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? `{${k}}`));
}
